import "./Residential.module.css";
import MainNavigation from "@/reusable_sections/Header";
import CompleteHvacMastery from "./sections/CompleteHvacMastery";
import OurRoofingExpertise from "./sections/OurRoofingExpertise";
import ReachOurTeam from "./sections/ReachOurTeam";
import Footer from "@/reusable_sections/Footer";
export default function ResidentialPage() {
  return <div>
      <MainNavigation />
      <CompleteHvacMastery />
      <OurRoofingExpertise />
      <ReachOurTeam />
      <Footer />
    </div>;
}